<template>
  <div
    class="btn btn-primary shadow-sm d-flex align-items-center px-3 py-0 h-30px h-md-40px"
    :class="{ disabled: disabled }"
    style="width: 170px;"
    :data-kt-menu-trigger="disabled ? null : 'click'"
    data-kt-menu-attach="parent"
    data-kt-menu-placement="bottom-end"
  >
    <AvatarBadge :avatar-url="selectedSociety?.image_url" :fullname="selectedSociety?.name" fallback-icon="fa fa-building" class="me-2" />
    <span class="text-truncate fw-semibold flex-grow-1 text-white">
      {{ selectedSociety?.name || $t('society') }}
    </span>
    <i class="bi bi-chevron-down fs-8 ms-2 text-white"></i>
  </div>

  <div class="menu menu-sub menu-sub-dropdown menu-column w-250px p-0" data-kt-menu="true">
    <div class="p-3 border-bottom">
      <input
        type="text"
        class="form-control form-control-sm"
        :placeholder="$t('common.search')"
        v-model="search"
        @click.stop
      />
    </div>

    <div class="mh-300px overflow-auto py-2">
      <div v-for="soc in filteredSocieties" :key="soc.id" class="menu-item px-3">
        <a
          href="#"
          class="menu-link d-flex align-items-center py-2 rounded"
          :class="soc.id === modelValue ? 'bg-primary text-white' : ''"
          @click.prevent="select(soc)">
          <AvatarBadge :avatar-url="soc.image_url" :fullname="soc.name" fallback-icon="fa fa-building" class="me-2" />
          <span class="text-truncate flex-grow-1">{{ soc.name }}</span>
          <i v-if="soc.id === modelValue" class="bi bi-check-lg ms-2 text-white"></i>
        </a>
      </div>
      <div v-if="!filteredSocieties.length" class="text-center text-muted py-3 fs-8">
        {{ $t('common.no_result') }}
      </div>
    </div>

    <div class="border-top" v-if="canCreate">
      <a href="#" class="menu-link d-flex align-items-center px-3 py-3 text-primary fw-semibold" @click.prevent="$emit('create')">
        <i class="bi bi-plus-circle fs-4 me-2"></i> {{ $t('header.create_society') }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick, onMounted, onUpdated } from 'vue'
import AvatarBadge from '@/components/AvatarBadge.vue'

const props = defineProps({
  societies: { type: Array, default: () => [] },
  modelValue: { type: [String, Number], default: null },
  canCreate: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue', 'create'])

const search = ref('')

const selectedSociety = computed(() => props.societies.find(s => s.id === props.modelValue))

const filteredSocieties = computed(() => {
  if (!search.value) return props.societies
  const q = search.value.toLowerCase()
  return props.societies.filter(s => (s.name || '').toLowerCase().includes(q))
})

function select(soc) {
  search.value = ''
  emit('update:modelValue', soc.id)
}

onMounted(() => {
  KTMenu.init()
})

onUpdated(() => {
  nextTick(() => {
    KTMenu.init()
  })
})
</script>

<style scoped>
.menu-link:hover {
  background-color: var(--bs-primary-light, #f1faff);
}
</style>
